import { Star } from "lucide-react";
import { useState } from "react";

export function Stars({ value = 0, size = 15, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} size={size}
          className={n <= Math.round(value) ? "text-amber fill-amber" : "text-border"}
          fill={n <= Math.round(value) ? "currentColor" : "none"} />
      ))}
    </span>
  );
}

export function StarInput({ value, onChange, size = 24 }) {
  const [hover, setHover] = useState(0);
  return (
    <span className="inline-flex items-center gap-1" data-testid="star-input">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)}
          onClick={() => onChange(n)} data-testid={`star-${n}`} className="transition-transform hover:scale-110">
          <Star size={size}
            className={n <= (hover || value) ? "text-amber fill-amber" : "text-border"}
            fill={n <= (hover || value) ? "currentColor" : "none"} />
        </button>
      ))}
    </span>
  );
}
